import { Http } from "@/util";

export function submitEvSimulate(param) {
  return Http.post("/admin/ev/submit_simulate", param);
}

export function getEvSimulateTask(taskId) {
  return Http.get("/admin/ev/simulate_task", { taskId, _hideLoading: true });
}

export function getEvPlanView(param) {
  return Http.get("/admin/ev/plan_view", param);
}

export function getEvPlanEpoch(param) {
  return Http.get("/admin/ev/plan_epoch", { ...(param || {}), _hideLoading: true });
}

export function submitEvOnlineSolve(param) {
  return Http.get("/admin/ev/submit_online_solve", { ...(param || {}), _hideLoading: true });
}

export function getEvPlanDeltaEvents(param) {
  return Http.get("/admin/ev/plan_delta_events", { ...(param || {}), _hideLoading: true });
}

export function getEvSellableView(param) {
  return Http.get("/admin/ev/sellable_view", param);
}

export function getEvOpAreaHourView(param) {
  return Http.get("/admin/ev/op_area_hour_view", param);
}

export function getEvSolveSummaryView(param) {
  return Http.get("/admin/ev/solve_summary_view", param);
}

export function getEvVehicleFinalView(param) {
  return Http.get("/admin/ev/vehicle_final_view", param);
}

export function getEvVehicleInitView(param) {
  return Http.get("/admin/ev/vehicle_init_view", param);
}

export function getEvTunableConfig(param) {
  return Http.get("/admin/ev/tunable_config", param);
}

export function applyEvTunableConfig(data) {
  const payload = { ...(data || {}) };
  return Http.post("/admin/ev/tunable_config/apply", { ...payload, _hideLoading: true });
}

export function getEvTemplateVehicles(param) {
  return Http.get("/admin/ev/template_vehicles", param);
}

export function listEvTemplateVehicleDates(param) {
  return Http.get("/admin/ev/template_vehicles/dates", param);
}

export function saveEvTemplateVehicles(data) {
  return Http.post("/admin/ev/template_vehicles/save", { ...(data || {}), _hideLoading: true });
}

export function deleteEvTemplateVehicles(data) {
  return Http.post("/admin/ev/template_vehicles/delete", { ...(data || {}), _hideLoading: true });
}

export function getEvUsableDrivers(param) {
  return Http.get("/admin/ev/usable_drivers", param);
}

export function listEvAssignCandidates(orderId) {
  return Http.get("/admin/ev/assign_candidates", { orderId });
}

export function assignEvOrder(data) {
  return Http.post("/admin/ev/assign_order", data || {});
}

export function revokeEvOrder(orderId) {
  return Http.get("/admin/ev/revoke_order", { orderId });
}

export function submitEvOpsSimulate(data) {
  return Http.post("/admin/ev/ops_simulate", { ...(data || {}), _hideLoading: true });
}

export function getEvOpsSimulateTask(taskId) {
  return Http.get("/admin/ev/ops_simulate_task", { taskId, _hideLoading: true });
}

export function getEvPlanInspect(param) {
  return Http.get("/admin/ev/plan_inspect", { ...(param || {}) });
}
